import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Getting Language Information",
description: "Learn how to access and display language-level information in a custom Freon-based web app. Initialize and use langInfo for projections, unit types, and the language name within your Svelte components.",
tags: [ "Freon", "Svelte", "Integration", "core", "core-svelte", "LanguageEnvironment", "langInfo", "ProjectionHandler", "WebappConfigurator", "InMemoryModel", "Flowbite", "ViewMenu", "ModelInfo", "NavBar"] ,
modifiedTime: "2025-11-07T17:20:18.645Z",
publishedTime: "2025-11-07T17:20:18.645Z"
    }
  };
};